<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<div class="header">
  <app-header-bar
    [title]="clientName"
    [showClientDetails]="false"
    [showButton]="false"
    [age]="_age"
    [dob]="_dob"
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="_dob != undefined || _dob != null"
  ></app-header-bar>
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      id="client-information"
      subtitle=""
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    [clientId]="clientId"
    [totalReviews]="_totalReviews"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [showBackButton]="true"
    (navigateBackClick)="previousRoute()"
  />
</div>
<br />
<div class="main-primary-card-container">
  <app-primary-card
    size="full"
    title="Reviews"
    subtitle=""
    class="main-primary-card"
    headerSize="small"
  >
    <div class="reviews-container">
      <div class="header-text">{{ 'Open Reviews' | translate }}</div>
      <app-table
        [dataSource]="openReviewsDS"
        [columnsToDisplay]="_openReviewsColumnsToDisplay"
        [columnDefinitions]="_openReviewsColumnDefinitions"
        [pageSize]="12"
        [kind]="'standard'"
        [showPager]="true"
        (onLinkButtonClick)="onTableLinkButtonClick($event)"
        (onLinkClick)="onTableLinkClick($event)"
        (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
      >
      </app-table>
    </div>
    <div class="reviews-container">
      <div class="header-text">{{ 'Archived Reviews' | translate }}</div>
      <app-table
        [dataSource]="archivedReviewsDS"
        [columnsToDisplay]="_archivedReviewsColumnsToDisplay"
        [columnDefinitions]="_archivedReviewsColumnDefinitions"
        [pageSize]="12"
        [kind]="'standard'"
        [showPager]="true"
        (onLinkButtonClick)="onTableLinkButtonClick($event)"
        (onLinkClick)="onTableLinkClick($event)"
        (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
      >
      </app-table>
    </div>
  </app-primary-card>
  <br />
</div>
